import { ErrorPage } from '@/pages/Layout/pages';
import { RouteObject } from 'react-router-dom';
import { Authorize } from '@/components';
import { lazy } from 'react';
import {
  BUSINESS_ROLE_GROUPS,
  EXTERNAL_OPERATOR_ROLE_GROUPS,
} from '@/components/security/AppRoles';

const Zones = lazy(() => import('../Zones'));
const ViewZone = lazy(() => import('../pages/ViewZone'));
const CreateZone = lazy(() => import('../pages/CreateZone'));

const ADMIN_PERMISSIONS = [
  ...BUSINESS_ROLE_GROUPS.operations,
  ...EXTERNAL_OPERATOR_ROLE_GROUPS.admin,
];

const ZonesRoutes: RouteObject[] = [
  {
    path: 'logistics-management/zones',
    element: (
      <Authorize
        permission={ADMIN_PERMISSIONS}
        fallback={<ErrorPage code={403} />}
      >
        <Zones />
      </Authorize>
    ),
  },
  {
    path: 'logistics-management/zone/:id',
    element: (
      <Authorize
        permission={ADMIN_PERMISSIONS}
        fallback={<ErrorPage code={403} />}
      >
        <ViewZone />
      </Authorize>
    ),
  },
  {
    path: 'logistics-management/zones/create',
    element: (
      <Authorize
        permission={ADMIN_PERMISSIONS}
        fallback={<ErrorPage code={403} />}
      >
        <CreateZone />
      </Authorize>
    ),
  },
];

export default ZonesRoutes;
